import { useEffect, useRef, useState } from 'react';

import { useAppSelector, useElementVisibility, useMedia } from '@/shared/hooks';

import { conditionModel } from '@/entities/condition';
import { toothModel } from '@/entities/tooth';

type UseMobileSimplifiedToothChartVisibilityProps = {
  mobileToothChartStyle: string;
};

export const useMobileSimplifiedToothChartVisibility = (
  props: UseMobileSimplifiedToothChartVisibilityProps,
) => {
  const { mobileToothChartStyle } = props;

  const { isMobile } = useMedia();
  const simplifiedChartRef = useRef<HTMLDivElement>(null);
  const [simplifiedChartHeight, setSimplifiedChartHeight] = useState(0);

  const conditionLoading = useAppSelector(
    conditionModel.selectors.selectLoading,
  );
  const toothLoading = useAppSelector(toothModel.selectors.selectLoading);

  const showToothChart =
    conditionLoading === 'succeeded' && toothLoading === 'succeeded';

  const mobileHeaderHeight =
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        '--mobileHeaderHeight',
      ),
    ) || 56;

  const isToothChartVisible = useElementVisibility(
    `.${mobileToothChartStyle}`,
    isMobile && showToothChart,
    `-${mobileHeaderHeight + simplifiedChartHeight}px 0px 0px 0px`,
  );

  const shouldShowMobileSimplifiedToothChart =
    !isToothChartVisible && showToothChart;

  useEffect(() => {
    if (simplifiedChartRef.current && shouldShowMobileSimplifiedToothChart) {
      const height = simplifiedChartRef.current.offsetHeight;

      if (height > 0) {
        setSimplifiedChartHeight(height);
      }
    }
  }, [shouldShowMobileSimplifiedToothChart]);

  return {
    simplifiedChartRef,
    shouldShowMobileSimplifiedToothChart,
  };
};
